import React, {useCallback, useMemo} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Routes as AppRoutes} from "./routes";
import "./App.css";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Login from "./features/auth/login/Login";

import CreatePassword from "./features/auth/createPassword/CreatePassword";
import ResetPassword from "./features/auth/resetPassword/ResetPassword";

import {isTokenExpired} from "./helpers/AccessControlUtils";
import {useDispatch, useSelector} from "react-redux";
import {setRedirectPath} from "./app/globalSlice";
import {Navigate, Outlet} from "react-router";
import Header from "./components/layout/header/Header";
import Sidebar from "./components/layout/sidebar/Sidebar";
import {Toaster} from "react-hot-toast";
import ForgetPassword from "./features/auth/forgetPassword/ForgetPassword";
import 'react-photo-view/dist/react-photo-view.css';

import CreateSurvey from "./features/survey/CreateSurvery";
import Survey from "./features/survey/Survey";
import SureveyDetails from "./features/survey/SureveyDetails";
import User from "./features/users/User";
import UserDetails from "./features/users/UserDetails";
import Setting from "./features/setting/Setting";
import Faq from "./features/setting/faq";
import FaqCategories from "./features/setting/FaqCategories";
import EditSurvey from "./features/survey/EditSurvey";
import SubmittedAnwers from "./features/users/SubmittedAnwers";
import OdoUserDetails from "./features/users/OdoUserDetails";
import Home from "./features/home/Home";
import StageMapping from "./features/stagemapping/stageMapping";
import SurveyCategory from "./features/surveyCategory/SurveyCategory";
import ProductView from "./features/home/ProductView";
import SurveyView from "./features/users/SurveyView";
import UserTarcking from "./features/user-tracking/UserTarcking";
import TrackingUserDetails from "./features/user-tracking/TrackingUserDetails";


function App() {
    const error = useSelector((state) => state.global.error);

    const PublicRoutes = React.memo(() => {
        return (
            <>
                <Outlet/> 
            </>
        );  
    }); 
    const PrivateRoutes = () => {
        const dispatch = useDispatch();
        const isUserLoggedIn = useMemo(() => localStorage.getItem("authToken"), []);
        const isAuthenticated = useMemo(() => isUserLoggedIn && !isTokenExpired(), [isUserLoggedIn]);
        const renderContent = useCallback(() => {
            if (!isAuthenticated) {
                // Capture the attempted path and redirect to login
                dispatch(setRedirectPath(window.location.pathname + window.location.search + window.location.hash));
                return <Navigate to="/login"/>;
            }
            return (
                <div className="wrapper">
                    <div className="inner_wrapper">
                        <Header/>
                        <Sidebar/>
                       <div className="p-3 min-vh-100 bg-cmn">
                         <Outlet/>
                       </div>
                    </div>
                </div>
            );
        }, [dispatch, isAuthenticated]);
        return renderContent();
    };


    return ( 
        <Router>
            
            <Toaster position="top-center" reverseOrder={false} />
            {!error &&
                <Routes>
                    {/* Public Routes without Layout */}
                    <Route element={<PublicRoutes/>}>
                        {!(localStorage.getItem("authToken") && !isTokenExpired()) && <Route path={AppRoutes.Default.path} element={<Login/>}/>}
                        <Route path={AppRoutes.Login.path} element={<Login/>}/>
                        <Route path={AppRoutes.CreatePassword.path} element={<CreatePassword/>}/>
                        <Route path={AppRoutes.ResetPassword.path} element={<ResetPassword/>}/>
                        <Route path={AppRoutes.ForgotPassword.path} element={<ForgetPassword/>}/>
                    </Route>
                    {/* Private Routes with Layout */}
                    <Route element={<PrivateRoutes/>}>
                        {(localStorage.getItem("authToken") && !isTokenExpired()) && <Route path={AppRoutes.Default.path} element={<SurveyCategory/>}/>}
                        <Route path={AppRoutes.Survey.path} element={<Survey/>}/>
                        <Route path={AppRoutes.Home.path} element={<Home/>}/>
                        <Route path={AppRoutes.ProductView.path} element={<ProductView/>}/>
                        <Route path={AppRoutes.StageMapping.path} element={<StageMapping/>}/>
                        <Route path={AppRoutes.SurveyCategory.path} element={<SurveyCategory/>}/>
                        <Route path={AppRoutes.CreateSurvey.path} element={<CreateSurvey/>}/>
                        <Route path={AppRoutes.EditSurvey.path} element={<EditSurvey/>}/>
                        <Route path={AppRoutes.SureveyDetails.path} element={<SureveyDetails/>}/>
                        <Route path={AppRoutes.User.path} element={<User/>}/>
                        <Route path={AppRoutes.UserDetails.path} element={<UserDetails/>}/>
                        <Route path={AppRoutes.SurveyView.path} element={<SurveyView/>}/>
                        <Route path={AppRoutes.OdoUserDetails.path} element={<OdoUserDetails/>}/>
                        <Route path={AppRoutes.SubmittedAnwers.path} element={<SubmittedAnwers/>}/>
                        <Route path={AppRoutes.Setting.path} element={<Setting/>}/>
                        <Route path={AppRoutes.Faq.path} element={<Faq/>}/>
                        <Route path={AppRoutes.FaqCategories.path} element={<FaqCategories/>}/>
                        <Route path={AppRoutes.UserTarcking.path} element={<UserTarcking/>}/>
                        <Route path={AppRoutes.TrackingUserDetails.path} element={<TrackingUserDetails/>}/>
                      
                    </Route>
                </Routes>
            }

        </Router>

    );
}

export default App;